import FetchPostDataNoAuthNEW from "../services/FetchPostDataNoAuthNEW";

export default async function FechPostLogin(body) {

  var url = "/api/auth/signin";

  var data = await FetchPostDataNoAuthNEW(url, body)

  return data;
}
